import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { supabase } from '../lib/supabase';

function ShortLinkRedirect() {
  const { code } = useParams();
  const navigate = useNavigate();
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    if (!code) {
      setNotFound(true);
      return;
    }

    async function resolveLink() {
      const { data, error } = await supabase
        .from('short_links')
        .select('target_url')
        .eq('code', code)
        .limit(1)
        .single();

      if (error || !data) {
        setNotFound(true);
        return;
      }

      // Fire-and-forget click count increment via raw SQL
      supabase.rpc('increment_short_link_click', { link_code: code }).then(() => {});

      navigate(data.target_url, { replace: true });
    }

    resolveLink();
  }, [code, navigate]);

  if (notFound) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="50vh"
        gap={2}
      >
        <Typography variant="h5">Link not found</Typography>
        <Typography variant="body1" color="text.secondary">
          This short link doesn't exist or may have expired.
        </Typography>
        <Link to="/products" style={{ color: '#8B4513' }}>
          Browse our products
        </Link>
      </Box>
    );
  }

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      minHeight="50vh"
    >
      <CircularProgress />
    </Box>
  );
}

export default ShortLinkRedirect;
